var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-loader"},[_c('div',{staticClass:"c-loader__spin"},[_c('i',{staticClass:"c-loader__icon fas fa-spinner-third fa-spin",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('br'),_c('span',{staticClass:"c-loader__label"},[_vm._v("Loading")])])])
}]

export { render, staticRenderFns }